import { Component } from '@angular/core';

@Component({
  selector: 'app-amcs-layout',
  templateUrl: './amcs-layout.component.html',
  styleUrls: ['./amcs-layout.component.css']
})
export class AmcsLayoutComponent {

configObj={module_cd:'ACMS',module_cd_camel_case:'Anganwadi Construction Monitoring System',database_name:'acms'};
}
